import type { Observation } from '../types';

export function makeClientSessionId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return Array.from({ length: 36 }, (_, i) => {
    if (i === 8 || i === 13 || i === 18 || i === 23) return '-';
    return Math.floor(Math.random() * 16).toString(16);
  }).join('');
}

function iriOrLit(v: string, asIri: boolean): string {
  return asIri ? `<${v}>` : `"${v.replace(/"/g, '\\"')}"`;
}

export function observationToNQuads(obs: Observation, subjectIri: string): string {
  const g = `<cogo:graph/observations/${obs.clientSessionId}>`;
  const s = `<${subjectIri}>`;
  const lines: string[] = [];
  const p = (pred: string, obj: string, asIri = false) => lines.push(`${s} <${pred}> ${iriOrLit(obj, asIri)} ${g} .`);
  p('rdf:type', 'cogo:Observation', true);
  p('cogo:observationKind', obs.kind);
  p('cogo:observedAt', obs.observedAt);
  p('cogo:session', obs.session);
  p('cogo:source', obs.source);
  p('cogo:clientSessionId', obs.clientSessionId);
  if (obs.forSemanticType) p('cogo:forSemanticType', obs.forSemanticType, true);
  if (obs.forPattern) p('cogo:forPattern', obs.forPattern, true);
  if (obs.forDesignSystem) p('cogo:forDesignSystem', obs.forDesignSystem, true);
  if (obs.pickedExample) p('cogo:pickedExample', obs.pickedExample, true);
  if (obs.rejectedExamples) for (const r of obs.rejectedExamples) p('cogo:rejectedExample', r, true);
  if (typeof obs.dwellMs === 'number') p('cogo:dwellMs', String(obs.dwellMs));
  if (obs.context) p('cogo:contextJson', JSON.stringify(obs.context));
  return lines.join('\n') + '\n';
}
